export default __webpack_public_path__ + "static/media/logo.72582bd8.png";